module.exports = __webpack_public_path__ + "static/media/new-york-61.d8550fb9.jpg";